import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import "./cervo.scss";
import StepCervoOne from "./steps/stepCervoOne";
import StepCervoTwo from "./steps/stepCervoTwo";
import StepCervoThree from "./steps/stepCervoThree";
import StepCervoFour from "./steps/stepCervoFour";
import StepCervoFive from "./steps/stepCervoFive";
function CervoPage(props) {
    useDispatch();
    const [step, setStep] = useState(1);

    const goTo = (number) => {

        setStep(number)
    }

    return (
        <>
            {step === 1 &&
                <StepCervoOne  goTo={goTo}  />
            }
            {step === 2 &&
                <StepCervoTwo  goTo={goTo}  />
            }
            {step === 3 &&
                <StepCervoThree  goTo={goTo}  />
            }
            {step === 4 &&
                <StepCervoFour  goTo={goTo}  />
            }
            {step === 5 &&
                <StepCervoFive  goTo={goTo}  />
            }

        </>
    )
}

export default withTranslation()(CervoPage);
